import { apiHttpClient } from './http'

export async function getAllContracts({ clientToken }) {
  try {
    const res = await apiHttpClient.get('/contracts', {
      params: { client_token: clientToken }
    })
    return res.data
  } catch (err) {
    throw new Error(err.response.statusText)
  }
}

export async function getContractsByDateRange({ clientToken, from, to }) {
  try {
    const res = await apiHttpClient.get('/contracts', {
      params: {
        client_token: clientToken,
        from,
        to
      }
    })
    return res.data
  } catch (err) {
    throw new Error(err.response.statusText)
  }
}

export async function addContract({ contract, clientToken }) {
  try {
    const res = await apiHttpClient.post('/contracts', contract, {
      params: { client_token: clientToken }
    })
    return res.data
  } catch (err) {
    throw new Error(err.response.statusText)
  }
}

export async function saveContractChanges({ id, changes, clientToken }) {
  try {
    const res = await apiHttpClient.patch(`/contracts/${id}`, changes, {
      params: { client_token: clientToken }
    })
    return res.data
  } catch (err) {
    throw new Error(err.response.statusText)
  }
}

export async function getContractsByEmail({ email, clientToken }) {
  try {
    const res = await apiHttpClient.get('/contracts', {
      params: {
        email,
        client_token: clientToken
      }
    })
    return res.data
  } catch (err) {
    throw new Error(err.response.statusText)
  }
}
